import CityPageTemplate from "../city-template/CityPageTemplate";
import { marysvilleConfig } from "./data";

export default function MarysvillePage() {
  return <CityPageTemplate config={marysvilleConfig} />;
}